import { useState, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import axiosInstance from "../../utils/axiosUtil";
import { getError } from "../../utils/error";
import LoadingBox from "../layout/LoadingBox";
import MessageBox from "../layout/MessageBox";

export default function ContactRequests() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 50,
    total: 0,
    pages: 0,
  });

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.get("/contacts?page=1&limit=50");

      setContacts(response.data.contacts || []);
      setPagination(response.data.pagination || pagination);
    } catch (err) {
      setError(getError(err));
      console.error("Error fetching contact requests:", err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };
  console.log(contacts);

  return (
    // <Container fluid className="page-section py-4">
    //   <Row className="mb-4">
    //     <Col md={12}>
    //       <h3 className="page-title">Contact Requests</h3>
    //       <p className="page-subtitle mb-0">
    //         View and manage contact form submissions from users.
    //       </p>
    //     </Col>
    //   </Row>

    //   <Row>
    //     <Col>
    //       <Card>
    //         <Card.Body>
    //           {error && (
    //             <MessageBox variant="danger">{error}</MessageBox>
    //           )}
    //           {message && (
    //             <MessageBox variant="success">{message}</MessageBox>
    //           )}

    //           {loading ? (
    //             <div className="py-4 text-center">
    //               <LoadingBox />
    //             </div>
    //           ) : contacts.length === 0 ? (
    //             <div className="text-center py-5">
    //               <p className="text-muted">No contact requests found.</p>
    //             </div>
    //           ) : (
    //             <>
    //               <div className="table-responsive">
    //                 <table className="table table-striped table-hover">
    //                   <thead>
    //                     <tr>
    //                       <th>Date</th>
    //                       <th>Name</th>
    //                       <th>Email</th>
    //                       <th>Company</th>
    //                       <th>Designation</th>
    //                       <th>Subject</th>
    //                       <th>Message</th>

    //                     </tr>
    //                   </thead>
    //                   <tbody>
    //                     {contacts.map((contact) => (
    //                       <tr key={contact._id}>
    //                         <td>{formatDate(contact.createdAt)}</td>
    //                         <td>{contact.name}</td>
    //                         <td>{contact.email}</td>
    //                         <td>
    //                           <span className="text-truncate d-inline-block" style={{ maxWidth: '200px' }} title={contact.subject}>
    //                             {contact.subject}
    //                           </span>
    //                         </td>
    //                         <td>
    //                           <span className="text-truncate d-inline-block" style={{ maxWidth: '300px' }} title={contact.message}>
    //                             {contact.message}
    //                           </span>
    //                         </td>
    //                       </tr>
    //                     ))}
    //                   </tbody>
    //                 </table>
    //               </div>
    //               {pagination.pages > 1 && (
    //                 <div className="d-flex justify-content-between align-items-center mt-3">
    //                   <div>
    //                     Showing {((pagination.page - 1) * pagination.limit) + 1} to{' '}
    //                     {Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total} requests
    //                   </div>
    //                 </div>
    //               )}
    //             </>
    //           )}
    //         </Card.Body>
    //       </Card>
    //     </Col>
    //   </Row>
    // </Container>
    <Container fluid className="page-section py-4">
      <Row className="mb-4">
        <Col md={12}>
          <h3 className="page-title">Contact Requests</h3>
          <p className="page-subtitle mb-0">
            View and manage contact form submissions from users.
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <Card.Body>
              {error && <MessageBox variant="danger">{error}</MessageBox>}
              {message && <MessageBox variant="success">{message}</MessageBox>}

              {loading ? (
                <div className="py-4 text-center">
                  <LoadingBox />
                </div>
              ) : contacts.length === 0 ? (
                <div className="text-center py-5">
                  <p className="text-muted">No contact requests found.</p>
                </div>
              ) : (
                <>
                  <div
                    className="table-responsive"
                    style={{ overflowX: "auto" }}
                  >
                    <table
                      className="table table-striped table-hover"
                      style={{ minWidth: "1200px" }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{ minWidth: "150px", whiteSpace: "nowrap" }}
                          >
                            Date
                          </th>
                          <th
                            style={{ minWidth: "120px", whiteSpace: "nowrap" }}
                          >
                            Name
                          </th>
                          <th
                            style={{ minWidth: "180px", whiteSpace: "nowrap" }}
                          >
                            Email
                          </th>
                          <th
                            style={{ minWidth: "150px", whiteSpace: "nowrap" }}
                          >
                            Company
                          </th>
                          <th
                            style={{ minWidth: "150px", whiteSpace: "nowrap" }}
                          >
                            Designation
                          </th>
                          <th
                            style={{ minWidth: "200px", whiteSpace: "nowrap" }}
                          >
                            Subject
                          </th>
                          <th
                            style={{ minWidth: "300px", whiteSpace: "nowrap" }}
                          >
                            Message
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {contacts.map((contact) => (
                          <tr key={contact._id}>
                            <td style={{ whiteSpace: "nowrap" }}>
                              {formatDate(contact.createdAt)}
                            </td>
                            <td>{contact.name}</td>
                            <td>{contact.email}</td>
                            <td>
                              <span
                                className="text-truncate d-inline-block"
                                style={{ maxWidth: "150px" }}
                                title={contact.company}
                              >
                                {contact.company || "_"}
                              </span>
                            </td>
                            <td>
                              <span
                                className="text-truncate d-inline-block"
                                style={{ maxWidth: "150px" }}
                                title={contact.designation}
                              >
                                {contact.designation || "_"}
                              </span>
                            </td>
                            <td>
                              <span
                                className="text-truncate d-inline-block"
                                style={{ maxWidth: "200px" }}
                                title={contact.subject}
                              >
                                {contact.subject}
                              </span>
                            </td>

                            <td
                              style={{
                                minWidth: "300px",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                            >
                              {contact.message}
                            </td>

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {pagination.pages > 1 && (
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        Showing {(pagination.page - 1) * pagination.limit + 1}{" "}
                        to{" "}
                        {Math.min(
                          pagination.page * pagination.limit,
                          pagination.total
                        )}{" "}
                        of {pagination.total} requests
                      </div>
                    </div>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
